module.exports = __webpack_public_path__ + "static/media/three-dots-vertical.4f6dd82e.svg";